import ButtonVariants from "@core-components/button/ButtonVariants";
import { Card, Flex, Image, Stack, Text } from "@mantine/core";
import AppSkeleton from "@modules/loader/AppSkeleton";
import CircleLoader from "@modules/loader/CircleLoader";
import { useLoaderStore } from "@modules/loader/useLoader.hook";
import { Link } from "react-router";

interface IBlogListItemProps {
  label: string;
  description: string;
  picture: string;
  href: string;
}

const BlogListItem: React.FC<IBlogListItemProps> = ({
  label,
  description,
  href,
  picture,
}) => {
  const isLoading = useLoaderStore().isLoadingBySkeleton();

  return (
    <Card
      withBorder
      classNames={{
        root: "bg-primary-darker border-primary-light",
      }}
      component={Link}
      padding="md"
      radius="md"
      shadow="sm"
      to={href}
    >
      <Card.Section>
        {isLoading && (
          <Flex className="min-h-[200px]" justify="center">
            <CircleLoader />
          </Flex>
        )}

        <Image alt={`Image du blog`} height={200} mah={200} src={picture} />
      </Card.Section>

      <Stack h={"100%"} justify="space-between" mt="md">
        <Stack gap={10}>
          <AppSkeleton>
            <Text
              classNames={{
                root: "text-primary-white !font-extrabold",
              }}
              fw={500}
              lineClamp={2}
              size="lg"
            >
              {label}
            </Text>
          </AppSkeleton>
          <AppSkeleton>
            <Text
              classNames={{
                root: "text-primary-white font-inter",
              }}
              lineClamp={4}
              size="md"
            >
              {description}
            </Text>
          </AppSkeleton>
        </Stack>
        <ButtonVariants.ReadMore className="hover:text-primary-white" />
      </Stack>
    </Card>
  );
};

export default BlogListItem;
